const _temp0 = require("url:../../assets/images/0.png");
const _temp1 = require("url:../../assets/images/1.png");
const _temp2 = require("url:../../assets/images/2.png");
const _temp3 = require("url:../../assets/images/3.png");
const _temp4 = require("url:../../assets/images/4.png");
const _temp5 = require("url:../../assets/images/5.png");
const _temp6 = require("url:../../assets/images/6.png");
const _temp7 = require("url:../../assets/images/7.png");
const _temp8 = require("url:../../assets/images/8.png");
const _temp9 = require("url:../../assets/images/9.png");
const _temp10 = require("url:../../assets/images/10.png");
const _temp11 = require("url:../../assets/images/11.png");
const _temp12 = require("url:../../assets/images/12.png");
const _temp13 = require("url:../../assets/images/13.png");
const _temp14 = require("url:../../assets/images/14.png");
const _temp15 = require("url:../../assets/images/15.png");
const _temp16 = require("url:../../assets/images/dnd-icon.png");
module.exports = {
  "0": _temp0,
  "1": _temp1,
  "2": _temp2,
  "3": _temp3,
  "4": _temp4,
  "5": _temp5,
  "6": _temp6,
  "7": _temp7,
  "8": _temp8,
  "9": _temp9,
  "10": _temp10,
  "11": _temp11,
  "12": _temp12,
  "13": _temp13,
  "14": _temp14,
  "15": _temp15,
  "dnd-icon": _temp16
}